import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// services
import levelService from "services/level.service";
// util
import Notifications from "views/Notifications/Notifications";

const styles = (theme) => ({
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
	},
});

class CadastrarNiveis extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 0,
			title: "",
			language: "english",
			notification: { show: false, message: "", type: "info" },
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const name = target.name;
		let value = target.type === "file" ? target.files[0] : target.value;

		this.setState({
			[name]: value,
		});
	}

	handleSubmit(event) {
		levelService
			.createLevel({
				order: parseFloat(this.state.order),
				title: this.state.title,
				language: this.state.language,
			})
			.then((res) =>
				this.showNotification(
					"Livro cadastrado com sucesso!",
					"success"
				)
			)
			.catch((err) =>
				this.showNotification(
					"Ocorreu um erro ao tentar cadastrar livro! " + err,
					"danger"
				)
			);
	}

	showNotification(message, type) {
		this.setState({
			notification: { show: true, message: message, type: type },
		});
		setTimeout(() => {
			this.setState({
				notification: { show: false, message: "", type: "info" },
			});
			this.props.onClose();
		}, 3000);
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12}>
						<Card>
							<CardHeader color="primary">
								<h4 className={classes.cardTitleWhite}>
									Cadastrar Livro
								</h4>
								<p className={classes.cardCategoryWhite}>
									Complete as informações para o cadastro
								</p>
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={12} sm={12} md={3}>
										<CustomInput
											labelText="Número de Ordem do Livro"
											id="order"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "number",
												name: "order",
												value: this.state.order,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={6}>
										<CustomInput
											labelText="Título do Livro"
											id="title"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "text",
												name: "title",
												value: this.state.title,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={3}>
										<CustomSelect
											labelText="Lingua"
											id="name"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "number",
												name: "language",
												value: this.state.language,
												onChange: this.handleChange,
											}}
											selectItems={[
												{
													key: "english",
													value: "english",
													label: "Inglês",
												},
												{
													key: "spanish",
													value: "spanish",
													label: "Espanhol",
												},
											]}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
							<CardFooter>
								<Button
									color="primary"
									type="submit"
									round
									onClick={(event) => {
										this.handleSubmit(event);
									}}
								>
									Cadastrar
								</Button>
							</CardFooter>
						</Card>
					</GridItem>
					{this.state.notification.show === true ? (
						<Notifications notification={this.state.notification} />
					) : null}
				</GridContainer>
			</div>
		);
	}
}

CadastrarNiveis.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CadastrarNiveis);
